import dayjs from 'dayjs';
import _ from 'lodash';
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

export const API = {
  dispatchBoard: {
    path: '/logbooks/dispatch-board?populate[id_driver_in_charge][populate][id_users_permissions_user][fields]=name,surname&populate[id_location][marina][$containsi]=&populate[id_yacht][populate][id_attendance][populate][id_provenence_list][populate][provenence]=%2A&populate[id_yacht][populate][id_yacht_members][populate][id_users_permissions_user]=%2A&populate[id_department]=%2A&populate[id_supplier]=%2A&populate[manager][populate][id_users_permissions_user][fields]=name,surname&populate[id_operator][populate][id_users_permissions_user][fields]=name,surname',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    transform: (data) => {
      const allLogbooks = data?.data || [];

      return {
        meta: data?.meta,
        data: allLogbooks
          .map((item) => {
            return {
              id: item?.id,
              attributes: {
                ...item?.attributes,
                collection_delivery_date_id: {
                  collection_delivery_date:
                    item?.attributes?.collection_delivery_date,
                  id: item?.id,
                },
                collection_delivery_time_id: {
                  collection_delivery_time:
                    item?.attributes?.collection_delivery_time,
                  id: item?.id,
                },
                id_driver_in_charge_id: {
                  id_driver_in_charge:
                    item?.attributes?.id_driver_in_charge?.data?.attributes
                      ?.id_users_permissions_user?.data?.attributes,
                  id: item?.attributes?.id_driver_in_charge?.data?.id,
                  id_operation: item?.id,
                },
                id_operator_id: {
                  id_operator:
                    item?.attributes?.id_operator?.data?.attributes
                      ?.id_users_permissions_user?.data?.attributes,
                  id: item?.id,
                },
                status_logbook_id: {
                  status_logbook: item?.attributes?.status_logbook,
                  id: item?.id,
                },
                delivery_manager_on_board:
                  item?.attributes?.id_yacht?.data?.attributes?.id_user_crew?.data?.filter(
                    (user) =>
                      user?.attributes?.is_delivery_manager_on_board === true
                  )?.[0] || null,
                pickup_suppliers_related:
                  _.get(item, 'attributes.pickup_suppliers_related', []),
                id_pickup_status: {
                  status: item?.attributes?.pickup_status,
                  total: item?.attributes?.pickup_status_details?.total || 0,
                  completed: item?.attributes?.pickup_status_details?.completed || 0,
                  percentage: item?.attributes?.completion_rate_percentage,
                },
                id_completion_percentage: {
                  status: item?.attributes?.pickup_status,
                  total: item?.attributes?.pickup_status_details?.total || 0,
                  completed: item?.attributes?.pickup_status_details?.completed || 0,
                  percentage: item?.attributes?.completion_rate_percentage,
                },
                id_departments: {
                  pickup_departments: item?.attributes?.pickup_departments?.join(', ')
                },
              },
            };
          }),
      };
    },
  },
  updateFromList: {
    path: '/logbooks/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
      },
    }),
  },
  dispatchBoardPDF: {
    path: '/dispatchBoardPDF',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    responseType: 'blob',
  },
};
